module.exports = __webpack_public_path__ + "media/interieur8h.741ac7d5.mp4";